import { useConnect } from '@lore/query-connect';

export default function useImpersonation() {
  const impersonations = useConnect('impersonation.find');

  return impersonations.data[0];
};
